import { useState, type JSX } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { createAppRouter } from "./router";

export function App(): JSX.Element {
  // Router を App mount ごとに生成し、既存の browser URL を初期状態として読む。
  const [router] = useState(createAppRouter);
  return <RouterProvider router={router} />;
}
